import {ComponentData} from "../../engine/tools/EntityManager";

export enum ButtonEvent {
    None,
    Down,
    UpClicked,
    UpCanceled,
    UpWhileHolding,
    DownWhileHolding,
}

export class Button implements ComponentData {
    isDown: boolean = false
    downImage: string
    upImage: string
    event: ButtonEvent

    constructor(options?: Partial<Button>) {
        Object.assign(this, options)
    }
}